<template>
    <div id="wrapper">
        <SidebarView :coaImports="true" :accounts="true" :accounts-visible="true" />
        <div class="d-flex flex-column" id="content-wrapper">
            <div id="content">
                <TopbarView />

                <div class="container-fluid">
                    <div>
                        <b-card no-body class="card-shape home-box">
                            <b-tabs card>
                                <b-tab title="COA Type Imports" active>
                                    <COATypesImport />
                                </b-tab>
                                <b-tab title="COAHead Imports" >
                                    <COAImports />
                                </b-tab>
                                <b-tab title="COASubheads Imports">
                                    <COASubImports />
                                </b-tab>
                                <b-tab title="COASubhead Transaction Imports">
                                    <COATransactionImport />
                                </b-tab>
                            </b-tabs>
                        </b-card>
                    </div>
                </div>
            </div>
            <footer></footer>
        </div>
        <!-- AI -->
         <ChatBot />
        <!-- End AI -->
        <a class="d-inline scroll-to-top" href="#page-top"><i class="fas fa-angle-up"></i></a>
    </div>
</template>
<script>
import SidebarView from "@/views/main/components/Sidebar.vue";
import TopbarView from "@/views/main/components/Topbar.vue";
import Footer from "@/views/main/components/Footer.vue";
import COAImports from "./COAImports.vue";
import COASubImports from "./COASubImports.vue";
import COATypesImport from "./COATypesImport.vue";
import COATransactionImport from "./COATransactionImport.vue";
import ChatBot from "@/views/components/AI/ChatBot.vue";

export default {
    components: {
        SidebarView,
        TopbarView,
        Footer,
        COAImports,
        COASubImports,
        COATypesImport,
        COATransactionImport,
        ChatBot,
    },
};
</script>